import { Injectable, OnInit } from "@angular/core";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { SelectionInterface } from "./Interfaces";
import { ApplicationsStepperComponent } from "../common/components/applications-stepper/applications-stepper.component";
import { ActivatedRoute, Router } from "@angular/router";
import { ApplicationService } from "./application.service";
import { ZeroDefaultControl } from "../common/zereDefaultControl";
@Injectable({
  providedIn: "root",
})
export class FormService {
  studentApplicationId: any;
  applicationData: any;

  constructor(private appService: ApplicationService) { }

  programSelectionForm = new FormGroup({
    selectProgram: new FormControl<any>(null, Validators.required),
    schedule: new FormControl<any>(null, Validators.required),
    startDate: new FormControl<any>(null, Validators.required),
    reasonForApplication: new FormControl<string>("", Validators.required),
  });

  personalInfoForm = new FormGroup({
    firstName: new FormControl("", Validators.required),
    middleName: new FormControl(""),
    lastName: new FormControl("", Validators.required),
    dateOfBirth: new FormControl("", Validators.required),
    ssn: new FormControl("", [Validators.required, Validators.minLength(8)]),
    email: new FormControl("", [Validators.required, Validators.email]),
    phoneNumber: new FormControl("", Validators.required),
    streetAddress: new FormControl("", Validators.required),
    city: new FormControl("", Validators.required),
    state: new FormControl("", Validators.required),
    zipCode: new FormControl("", [
      Validators.required,
      Validators.pattern("^[0-9]*$"),
    ]),
    permanentStreetAddress: new FormControl(""),
    permanentCity: new FormControl(""),
    permanentState: new FormControl(""),
    permanentZipCode: new FormControl("", Validators.pattern("^[0-9]*$")),
    messageConsent: new FormControl<boolean>(false),
  });

  programInfoForm = new FormGroup({
    programTitle: new FormControl("", Validators.required),
    completionAward: new FormControl("", Validators.required),
    startDate: new FormControl("", Validators.required),
    startTime: new FormControl("", Validators.required),
    endDate: new FormControl("", Validators.required),
    endTime: new FormControl("", Validators.required),
    classDays: new FormGroup({
      monday: new FormControl(""),
      tuesday: new FormControl(""),
      wednesday: new FormControl(""),
      thursday: new FormControl(""),
      friday: new FormControl(""),
      saturday: new FormControl(""),
      sunday: new FormControl(""),
      onlineFlex: new FormControl(""),
      onlineHybridFlex: new FormControl(""),
    }),
    // programDurationDays = new FormControl(null, [Validators.required, Validators.min(1)]],
    // programDurationWeeks: [null, [Validators.required, Validators.min(1)]],
    // programDurationMonths: [null, [Validators.required, Validators.min(0)]],
    programDuration: new FormControl("", [Validators.required]),
    // programDurationWeeks: new ZeroDefaultControl(0, [Validators.min(1)]),
    // programDurationMonths: new ZeroDefaultControl(0, [Validators.min(0)]),
  });

  emergencyContactForm = new FormGroup({
    emergencyFirstName: new FormControl("", Validators.required),
    emergencyMiddleName: new FormControl(""),
    emergencyLastName: new FormControl("", Validators.required),
    emergencyEmailAddress: new FormControl("", [
      Validators.required,
      Validators.email,
    ]),
    emergencyPhoneNumber: new FormControl("", Validators.required),
    fulladdress: new FormControl("", Validators.required),
    relationship: new FormControl("", Validators.required),
  });

  ethnicityForm = new FormGroup({
    gender: new FormControl("", Validators.required),
    ethnicity: new FormControl("", Validators.required),
  });

  disabilityForm = new FormGroup({
    disabilityPresence: new FormControl("", Validators.required),
    disability: new FormControl("", Validators.required),
    typeOfAccommodation: new FormControl("", Validators.required),
  });

  practicalNursingForm = new FormGroup({
    transcript: new FormControl<any | null>(null),
    humanAnatomyAndPhysiology1: new FormControl("", Validators.required),
    humanAnatomyAndPhysiology1Course: new FormControl(false),

    humanAnatomyAndPhysiology2: new FormControl("", Validators.required),
    humanAnatomyAndPhysiology2Course: new FormControl(false),

    medicalTerminology: new FormControl("", Validators.required),
    medicalTerminologyCourse: new FormControl(false),

    pharmacologyOfNursing: new FormControl("", Validators.required),
    pharmacologyOfNursingCourse: new FormControl(false),

    preNursing: new FormControl(false),

    refresher: new FormControl(false),
    refresherCourse: new FormControl(""),
  });

  programOptionsForm = new FormGroup({
    preNursing: new FormControl("", Validators.required),
    preNursingCourses: new FormControl<any>(""), // Ensure it's typed correctly
    transcript: new FormControl<any | null>(null),
    requiredPreNursingCourse: new FormControl("", Validators.required),
  });

  studentVerificationForm = new FormGroup({
    firstTimeProgram: new FormControl("", Validators.required),
    retakingProgram: new FormControl("", Validators.required),
    pastProgram: new FormControl("", Validators.required),
  });

  studentSourceForm = new FormGroup({
    source: new FormControl("", Validators.required),
    studentSourceText: new FormControl(""),
  });

  usMilitaryRecordForm = new FormGroup({
    currentMilitaryOrVeteran: new FormControl("", Validators.required),
    militaryBranch: new FormControl(""),
    startDate: new FormControl(""),
    endDate: new FormControl(""),
    dischargeStatus: new FormControl(""),
  });

  educationalBackgroundForm = new FormGroup({
    highestEducation: new FormControl("", Validators.required),
    canReadWriteEnglish: new FormControl("", Validators.required),
    highSchoolName: new FormControl(null),
    highSchoolGraduationYear: new FormControl<any>(null),
    collegeName: new FormControl(null),
    major: new FormControl(""),
    gpa: new FormControl<any>(null),
    graduatedCollege: new FormControl(""),
    collegeGraduationMonthYear: new FormControl(""),
    universityName: new FormControl(""),
    universityMajor: new FormControl(""),
    universityGpa: new FormControl(""),
    graduatedUniversity: new FormControl(""),
    universityGraduationMonthYear: new FormControl(""),
  });

  employmentForm = new FormGroup({
    employmentStatus: new FormControl("", Validators.required),
    employerName: new FormControl(""),
    startDate: new FormControl(""),
    position: new FormControl(""),
    isCurrentlyWorkingForEmployer: new FormControl(false),
    // currentEmployer: new FormControl(""),
    hourlypay: new FormControl<number | null>(null, Validators.min(0)),
  });

  citizenshipForm = new FormGroup({
    countryOfBirth: new FormControl("United States", Validators.required),
    countryOfCitizenship: new FormControl(""),
    usCitizen: new FormControl("", Validators.required),
    permanentResidentStatus: new FormControl(""),
    qualifiedImmigrant: new FormControl(""),
    alienNumber: new FormControl(""),
    visaStatus: new FormControl(""),
    immigrantStatus: new FormControl(""),
    isPermanentResident: new FormControl(""),
    hasVisa: new FormControl(""), // Add this control
    I94: new FormControl(""),
  });

  backgroundInfoForm = new FormGroup({
    criminalHistory: new FormControl("", Validators.required),
    reasonOne: new FormControl(""),
    healthcareViolation: new FormControl("", Validators.required),
    reasonTwo: new FormControl(""),
    disciplinaryActions: new FormControl("", Validators.required),
    reasonThree: new FormControl(""),
    credentialActions: new FormControl("", Validators.required),
    reasonFour: new FormControl(""),
  });

  certificationForm = new FormGroup({
    toggleone: new FormControl("", Validators.required),
    toggletwo: new FormControl("", Validators.required),
    togglethree: new FormControl("", Validators.required),
    togglefour: new FormControl("", Validators.required),
    togglefive: new FormControl("", Validators.required),
    togglesix: new FormControl("", Validators.required),
    reasonOne: new FormControl(""),
    reasonTwo: new FormControl(""),
    reasonThree: new FormControl(""),
    reasonFour: new FormControl(""),
    reasonFive: new FormControl(""),
    reasonSix: new FormControl(""),
  });
  // "reqPhysicalExam": true,
  // "reqHealthScreen": true,
  // "reqBLS": true,
  // "reqBackgroundCheck": true,
  // "reqDrugScreen": true
  documentUploadForm = new FormGroup({
    Id: new FormControl<File | null>(null),
    collegeTranscript: new FormControl<File | null>(null),
    highSchoolTranscript: new FormControl<File | null>(null),
    ssn: new FormControl<File | null>(null),
    cna: new FormControl<File | null>(null),
    drugScreen: new FormControl<File | null>(null),
    backgroundCheck: new FormControl<File | null>(null),
    bls: new FormControl<File | null>(null),
    healthScreen: new FormControl<File | null>(null),
    physicalExam: new FormControl<File | null>(null),
  });
  statementOfUnderstandingForm = new FormGroup({
    isTermsAndConditions: new FormControl(false, Validators.required),
  });

  signatureForm = new FormGroup({
    signature: new FormControl<Blob | null>(null),
    signatureDate: new FormControl("", Validators.required),
    paymentOption: new FormControl(""),
    sponsorName: new FormControl(""),
    fullname: new FormControl("", Validators.required),
  });
  approvalForm = new FormGroup({
    fullname: new FormControl("", Validators.required),
    approvalDate: new FormControl("", Validators.required),
    areDocumentProvidedValid: new FormControl(""),
    adminProvidedStatus: new FormControl(""),
    reasonForRejectingApplication: new FormControl(""),
  });
}
